module.exports = __webpack_public_path__ + "static/media/leftArrowIcon.926fb3c4.svg";